import {getGeoLocation} from '@/lib/locale/geoLocaltion'
import type {SupportedLocales} from '@/lib/locale/locale'
import {
  type Product,
  type RawBookmarkedProduct,
  transformBookmarkedProducts,
} from '@/models/productModel'
import call from '@/utils/api/call'
import shouldLogError from '@/utils/api/shouldLogError'
import UnexpectedError from '@/utils/api/UnexpectedError'

export async function getBookmarks({
  locale,
  signal,
}: {
  locale: SupportedLocales
  signal: AbortSignal
}) {
  return call
    .post<RawBookmarkedProduct[]>(
      '/api/model/bookmark/',
      {
        localization: {
          locale,
          geo_location: getGeoLocation(),
        },
        data: {
          action: 'load',
        },
      },
      {
        signal,
      },
    )
    .then(res => {
      return transformBookmarkedProducts(res.data)
    })
    .catch(e => {
      if (shouldLogError(e)) {
        console.error('Cannot fetch bookmark', e)
      }
      throw e
    })
}

export async function bookmark({
  retailer,
  id,
  isRemove,
  signal,
  locale,
}: {
  retailer: Product['retailer']
  id: Product['id']
  isRemove?: boolean
  signal?: AbortSignal
  locale: SupportedLocales
}) {
  const action = isRemove ? 'delete' : 'insert'

  return call
    .post(
      '/api/model/bookmark/',
      {
        localization: {
          locale,
          geo_location: getGeoLocation(),
        },
        data: {
          retailer,
          id,
          action,
        },
      },
      {
        signal,
      },
    )
    .then(() => {
      // empty
    })
    .catch(e => {
      if (shouldLogError(e)) {
        console.error(`Cannot ${action} bookmark`, e)
      }
      throw new UnexpectedError(e)
    })
}
